<footer>
    <div class="footer">
        Roboze &copy; {{currentYear}}. {{'landing-page.all-rights-reserved' | translate }}. {{'common.version' | translate}}: {{version()}}
    </div>
</footer>